import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Lottie from "react-lottie";
import * as location from "../Lottie/1055-world-locations.json";
import * as success from "../Lottie/1127-success.json";

import App from "../App";

const defaultOptions1 = {
  loop: true,
  autoplay: true,
  animationData: location.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: success.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function PreLoader() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(undefined);
  const [completed, setCompleted] = useState(undefined);

  useEffect(() => {
    setTimeout(() => {
      fetch("https://jsonplaceholder.cypress.io/todos/1")
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          setData(json);
          setLoading(true);

          setTimeout(() => {
            setCompleted(true);
          }, 1000);
        });
    }, 250);
  }, []);

  return (
    <>
      {!completed ? (
        <>
          {!loading ? (
            <>
              <div className="w-100 header">
                <div className="w-100 header-top bg-dark d-flex align-items-center">
                  <Lottie
                    className="bg-dark"
                    options={defaultOptions1}
                    height={400}
                    width={400}
                  />
                </div>
                <div className="w-100 bg-dark header-bottom"></div>
              </div>
            </>
          ) : (
            <>
              <div className="w-100 header">
                <div className="w-100 header-top bg-dark d-flex align-items-center">
                  <Lottie options={defaultOptions2} height={400} width={400} />
                </div>
                <div className="w-100 bg-dark header-bottom"></div>
              </div>
            </>
          )}{" "}
        </>
      ) : (
        <App />
      )}
    </>
  );
}

export default PreLoader;
